module.exports = __webpack_public_path__ + "static/img/buzzer12v-1.2ecbade.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/buzzer12v-1.svg
// module id = cABg
// module chunks = 0